import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import Select from "../../../componentsReusable/Select";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const MakesSelect = props => {
  const { t } = useTranslation('tec_rmi');
  const [makeId, setMakeId] = useState(props.makeId)
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useDidMountEffect(() => {
    fetchData()
  })

  useAfterUpdateEffect(() => {
    props.onChange(makeId)
  }, [makeId])

  useAfterUpdateEffect(() => {
    if(makeId !== props.makeId){
      setMakeId(props.makeId)
    }
  }, [props.makeId])

  useAfterUpdateEffect(() => {
    if(props.makeName && data.length > 0){
      const make = data.find(make => make.MakeName.toLowerCase() === props.makeName.toLowerCase())
      if(make){
        setMakeId(make.MakeId)
      }
    }
  }, [data])

  useAfterUpdateEffect(() => {
    fetchData()
  }, [props.showCar, props.showTruck, props.showBike])

  const fetchData = () => {
    setData([])
    setLoading(true)

    apiUser.tecRmi.vehicleTree.makeList({
      showCar: props.showCar,
      showTruck: props.showTruck,
      showBike: props.showBike,
    }).then(res => {
      setData(res.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const parseDataToOption = (make) => ({
    value: make.MakeId,
    label: make.MakeName,
  })

  return <Select
    placeholder={t('makes_select.placeholder')}
    isLoading={loading}
    options={data.map(parseDataToOption)}
    onChange={setMakeId}
    value={makeId}
  />};

MakesSelect.propTypes = {
  makeId: PropTypes.number,
  makeName: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default MakesSelect;